var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect2, _path22, _path23, _path24, _g, _path25, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.787109,
    y: 0.826172,
    width: 350,
    height: 233,
    fill: "#D38D8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.252 144.488C239.252 141.175 241.938 138.488 245.252 138.488H252.992C256.306 138.488 258.992 141.175 258.992 144.488V155.358C258.992 158.672 256.306 161.358 252.992 161.358H245.252C241.938 161.358 239.252 158.672 239.252 155.358V144.488Z",
    fill: "#191244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.094 144.488C286.094 141.175 288.78 138.488 292.094 138.488H299.834C303.147 138.488 305.834 141.175 305.834 144.488V155.358C305.834 158.672 303.147 161.358 299.834 161.358H292.094C288.78 161.358 286.094 158.672 286.094 155.358V144.488Z",
    fill: "#191244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.672 75.0293C232.672 70.611 236.254 67.0293 240.672 67.0293H304.415C308.834 67.0293 312.415 70.611 312.415 75.0293V146.392C312.415 150.81 308.834 154.392 304.415 154.392H240.672C236.254 154.392 232.672 150.81 232.672 146.392V75.0293Z",
    fill: "#8F87F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304.415 67.0293H240.672C236.254 67.0293 232.672 70.611 232.672 75.0293V80.0823L290.184 154.392H304.415C308.834 154.392 312.415 150.81 312.415 146.392V75.0293C312.415 70.611 308.834 67.0293 304.415 67.0293Z",
    fill: "#353071"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.672 131.195H312.415V134.462H232.672V131.195Z",
    fill: "#353071"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.415 134.462V131.195H272.242L274.701 134.462H312.415Z",
    fill: "#120E47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.254 78.3809C239.254 76.1717 241.045 74.3809 243.254 74.3809H301.834C304.043 74.3809 305.834 76.1717 305.834 78.3809V104.442C305.834 106.651 304.043 108.442 301.834 108.442H243.254C241.045 108.442 239.254 106.651 239.254 104.442V78.3809Z",
    fill: "#C3CCFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.834 74.3809H243.254C241.045 74.3809 239.254 76.1717 239.254 78.3809V87.2006C239.254 88.0888 239.55 88.9517 240.094 89.6534L253.478 106.895C254.236 107.871 255.402 108.442 256.638 108.442H301.834C304.043 108.442 305.834 106.651 305.834 104.442V78.3809C305.834 76.1717 304.043 74.3809 301.834 74.3809Z",
    fill: "#9AA5E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M247.57 74.3809H255.936L272.569 108.442H264.203L247.57 74.3809Z",
    fill: "#F3F5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.994 74.3809H261.539L278.171 108.442H275.627L258.994 74.3809Z",
    fill: "#F3F5FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M258.994 140.488C258.994 139.384 259.89 138.488 260.994 138.488H284.095C285.199 138.488 286.095 139.384 286.095 140.488V145.523C286.095 146.627 285.199 147.523 284.095 147.523H260.994C259.89 147.523 258.994 146.627 258.994 145.523V140.488Z",
    fill: "#353071"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M286.096 146.677V140.488C286.096 139.384 285.2 138.488 284.096 138.488H277.912L284.579 147.191C284.739 147.4 284.987 147.523 285.25 147.523C285.717 147.523 286.096 147.144 286.096 146.677Z",
    fill: "#120E47"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.555 140.9C260.555 140.348 261.002 139.9 261.555 139.9H283.536C284.089 139.9 284.536 140.348 284.536 140.9V145.108C284.536 145.661 284.089 146.108 283.536 146.108H261.555C261.002 146.108 260.555 145.661 260.555 145.108V140.9Z",
    fill: "#F3F5FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284.536 145.608V140.9C284.536 140.348 284.089 139.9 283.536 139.9H279.031L283.771 146.108H284.036C284.312 146.108 284.536 145.885 284.536 145.608Z",
    fill: "#6762AA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.254 140.9C239.254 140.348 239.702 139.9 240.254 139.9H250.215C250.767 139.9 251.215 140.348 251.215 140.9V145.108C251.215 145.661 250.767 146.108 250.215 146.108H240.254C239.702 146.108 239.254 145.661 239.254 145.108V140.9Z",
    fill: "#353071"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M266.178 145.046V140.904H267.734C268.683 140.904 269.189 141.482 269.192 142.277C269.189 143.069 268.677 143.644 267.722 143.644H266.921V145.046H266.178ZM266.921 143.032H267.619C268.18 143.029 268.432 142.715 268.432 142.277C268.432 141.834 268.18 141.528 267.619 141.528H266.921V143.032Z",
    fill: "#353071"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M270.016 145.092C269.77 145.092 269.567 144.891 269.57 144.645C269.567 144.405 269.77 144.208 270.016 144.205C270.253 144.208 270.456 144.405 270.456 144.645C270.456 144.891 270.253 145.092 270.016 145.092Z",
    fill: "#353071"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M271.194 145.046V140.904H272.75C273.7 140.904 274.206 141.482 274.209 142.277C274.206 143.069 273.694 143.644 272.739 143.644H271.938V145.046H271.194ZM271.938 143.032H272.636C273.196 143.029 273.448 142.715 273.448 142.277C273.448 141.834 273.196 141.528 272.636 141.528H271.938V143.032Z",
    fill: "#353071"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M275.507 140.904V145.046H274.775V140.904H275.507Z",
    fill: "#353071"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M277.584 145.109C276.649 145.109 276.074 144.485 276.074 143.513C276.074 142.552 276.657 141.9 277.544 141.9C278.305 141.9 278.962 142.377 278.962 143.467V143.696H276.795C276.806 144.225 277.118 144.54 277.59 144.537C277.91 144.54 278.124 144.402 278.219 144.216H278.934C278.802 144.754 278.305 145.109 277.584 145.109ZM276.797 143.198H278.265C278.262 142.775 277.976 142.466 277.555 142.466C277.118 142.466 276.823 142.803 276.797 143.198Z",
    fill: "#353071"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M293.873 140.9C293.873 140.348 294.321 139.9 294.873 139.9H304.834C305.387 139.9 305.834 140.348 305.834 140.9V145.108C305.834 145.661 305.387 146.108 304.834 146.108H294.873C294.321 146.108 293.873 145.661 293.873 145.108V140.9Z",
    fill: "#120E47"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 228.75,
    y: 91.5391,
    width: 3.92265,
    height: 1.35141,
    fill: "#353071"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.441 92.4121C224.441 91.8598 224.889 91.4121 225.441 91.4121H229.45C230.002 91.4121 230.45 91.8598 230.45 92.4121V99.3863C230.45 99.9386 230.002 100.386 229.45 100.386H225.441C224.889 100.386 224.441 99.9386 224.441 99.3863V92.4121Z",
    fill: "#353071"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224.904 92.9902C224.904 92.438 225.352 91.9902 225.904 91.9902H228.987C229.539 91.9902 229.987 92.4379 229.987 92.9902V98.8079C229.987 99.3602 229.539 99.8079 228.987 99.8079H225.904C225.352 99.8079 224.904 99.3602 224.904 98.8079V92.9902Z",
    fill: "#C3CCFB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M229.987 99.0236V98.8573C229.987 98.6861 229.94 98.5182 229.853 98.3711L226.269 92.349C226.137 92.1265 225.897 91.9902 225.638 91.9902C225.233 91.9902 224.904 92.3189 224.904 92.7244V93.1839C224.904 93.3671 224.955 93.5469 225.05 93.7034L228.532 99.4311C228.674 99.6651 228.929 99.8079 229.202 99.8079C229.636 99.8079 229.987 99.4568 229.987 99.0236Z",
    fill: "#F3F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_569_27158)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.994,
    y: 113.545,
    width: 27.1012,
    height: 1.61941,
    rx: 0.809707,
    fill: "#120E47"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258.994 114.092V114.324C258.994 114.788 259.37 115.164 259.834 115.164L258.994 114.092Z",
    fill: "#353071"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_569_27158)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.994,
    y: 116.951,
    width: 27.1012,
    height: 1.61941,
    rx: 0.809707,
    fill: "#120E47"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_569_27158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.484 116.951H259.804C259.357 116.951 258.994 117.314 258.994 117.761C258.994 118.208 259.357 118.571 259.804 118.571H262.473L261.661 117.527C261.379 117.164 260.944 116.951 260.484 116.951Z",
    fill: "#353071"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_569_27158)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.994,
    y: 120.359,
    width: 27.1012,
    height: 1.61941,
    rx: 0.809707,
    fill: "#120D47"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_569_27158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.251 120.359H259.804C259.357 120.359 258.994 120.722 258.994 121.169C258.994 121.616 259.357 121.979 259.804 121.979H265.105L264.817 121.611C264.2 120.821 263.254 120.359 262.251 120.359Z",
    fill: "#353071"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_569_27158",
    x: 258.994,
    y: 113.545,
    width: 27.1016,
    height: 1.81914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469945 0 0 0 0 0.0351389 0 0 0 0 0.183333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_569_27158",
    x: 258.994,
    y: 116.951,
    width: 27.1016,
    height: 1.81914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469945 0 0 0 0 0.0351389 0 0 0 0 0.183333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_569_27158",
    x: 258.994,
    y: 116.951,
    width: 3.47852,
    height: 1.81914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0704896 0 0 0 0 0.0523437 0 0 0 0 0.279167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_569_27158",
    x: 258.994,
    y: 120.359,
    width: 27.1016,
    height: 1.81914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469945 0 0 0 0 0.0351389 0 0 0 0 0.183333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27158"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_569_27158",
    x: 258.994,
    y: 120.359,
    width: 6.11133,
    height: 1.81914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0704896 0 0 0 0 0.0523437 0 0 0 0 0.279167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_569_27158"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport06);
export default __webpack_public_path__ + "static/media/transport_06.cb1762718e9cca829ce21a2586f6d8e8.svg";
export { ForwardRef as ReactComponent };